<template lang="pug">
.box
  .box-body
    .alert.alert-info(v-if="!onLoading('fetch-override-pricebook-products-count')")
      template(v-if="productsPoolCount > 0")
        | Adding {{ productsPoolCount }} products into pricebook
      template(v-else)
        | No products found in the selected category

    override-values-form(:onChange="onOverrideValuesChange")
  .box-footer.b-t.text-right
    button.btn.m-r-sm(:disabled="onLoading('add-batch-override-entries')" @click="cancel") Cancel
    button.btn.primary(:disabled="!canSubmit" @click="createEntries") Setup
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OverrideValuesForm from './override-values-form';

export default {
    components: {
        OverrideValuesForm,
    },

    props: {
        pricebookId: {
            type: Number,
            required: true,
        },
        onCancel: {
            type: Function,
            required: true,
        },
    },

    data: function() {
        return {
            category: null,
            overrideEntry: {
                price_adjustment_mode: 'none',
                price: '0',
            },
        };
    },

    computed: {
        canSubmit: function() {
            return (
                !this.onLoading('fetch-override-pricebook-products-count') &&
                this.productsPoolCount > 0
            );
        },
        ...mapGetters('override_pricebook', ['productsPoolCount']),
    },

    created() {
        let params = {
            pricebookId: this.pricebookId,
            filters: {},
        };
        this.getOverridePricebookProductsCount(params);
    },

    methods: {
        onOverrideValuesChange: function(val) {
            this.overrideEntry = val;
        },
        cancel: function() {
            this.onCancel();
        },
        async createEntries() {
            try {
                await this.addBatchEntries({
                    pricebookId: this.pricebookId,
                    filters: {},
                    params: this.overrideEntry,
                });
                this.showToastrSuccess();
                this.getOverridePricebook(this.pricebookId);
            } catch (e) {
                this.showApiError(e);
            }
        },
        ...mapActions('override_pricebook', [
            'getOverridePricebook',
            'getOverridePricebookProductsCount',
            'addBatchEntries',
        ]),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/batch/all-products.vue